import React from 'react'

const Suppliers = ({ data, title }) => {
  if (!data) return <div></div>
  return <div className='max-w-screen-lg w-full mx-auto mt-10 px-10 2xl:px-0'>
    <h3 className='font-syne--20 font-bold mb-5'>{title}</h3>
    <div>
      {data.map(supplier => {
        const { name, phone, site } = supplier.attributes
        return <div key={name + phone} className='font-montserrat--18 my-5 sm:my-0 sm:grid grid-cols-3 gap-2'>
          <p>{name}</p>
          <div style={{ color: "#B7964E" }} dangerouslySetInnerHTML={{ __html: site }}></div>
          <p className='sm:text-right lg:text-left'>{phone}</p>
        </div>
      })}
    </div>
  </div>
}

export default Suppliers
